/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The box spans the interquartile range; the line is the median.`)
};

const es_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La caja abarca el rango intercuartílico; la línea es la mediana.`)
};

const de_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Box umfasst den Interquartilsabstand; die Linie ist der Median.`)
};

const nl_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De box beslaat het interkwartielbereik; de lijn is de mediaan.`)
};

const fr_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La boîte s'étend sur l'intervalle interquartile ; la ligne est la médiane.`)
};

const it_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scatola copre l'intervallo interquartile; la linea è la mediana.`)
};

const pt_br2_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A caixa abrange a amplitude interquartil; a linha é a mediana.`)
};

const pt_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A caixa abrange a amplitude interquartil; a linha é a mediana.`)
};

const ja_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱は四分位範囲を表し、線は中央値です。`)
};

const zh_box_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱体跨越四分位距；横线表示中位数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_ex2", locale)
	if (locale === "en") return en_box_ex2(inputs)
	if (locale === "es") return es_box_ex2(inputs)
	if (locale === "de") return de_box_ex2(inputs)
	if (locale === "nl") return nl_box_ex2(inputs)
	if (locale === "fr") return fr_box_ex2(inputs)
	if (locale === "it") return it_box_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_box_ex2(inputs)
	if (locale === "pt") return pt_box_ex2(inputs)
	if (locale === "ja") return ja_box_ex2(inputs)
	return zh_box_ex2(inputs)
};